import { ApolloError } from '@apollo/client';
import { useUnauthorizedAccessGuardContext } from 'src/providers/UnauthorizedAccessGuardProvider';
import { isUnauthorizedError } from '../apollo/links/createOnErrorLink/utils/isUnauthorizedError';

export const useUnauthorizedAccessGuard = (error: ApolloError | undefined) => {
    const { raiseUnauthorizedAccess } = useUnauthorizedAccessGuardContext();
    if (isUnauthorizedError(error?.graphQLErrors)) {
        raiseUnauthorizedAccess();
    }
};
